<div class="top-bar-wrapper container-xl">
  <div class="top-bar-left">
    <a class="nostyle" routerLink="/">
      <div class="top-bar-img">
        <img src="assets/logo-blue.svg" alt="application-logo" />
      </div>
      <div *ngIf="!(authService.permissions$ | async)?.isFreemium; else freemiumLogo" class="top-bar-text">WORLD DATA PRO</div>
      <ng-template #freemiumLogo>
        <div data-destid="freemium-logo" class="top-bar-text">WORLD DATA PRO <span>Freemium</span> by <b>WORLD DATA LAB</b></div>
      </ng-template>
    </a>
  </div>
  <div class="top-bar-right">
    <div class="account-menu" *ngIf="authService.isLoggedIn(); else demo">
      <div class="row">
        <div class="col-9 d-flex justify-content-end align-items-center">
          <mpro-categories-switch *ngIf="!(authService.permissions$ | async)?.isFreemium; else submitRequest"></mpro-categories-switch>
          <ng-template #submitRequest>
            <div>
              <button
                (click)="authService.openFreemiumRequestModal.next({isOpen: true, requestCategory: ''})"
              class="mpro-btn mpro-btn-primary"
            >
              <span>call me back</span>
            </button>
          </div>
          </ng-template>
        </div>
        <div class="col-3">
          <mpro-panel-dropdown [name]="authService.getCurrentFullName()"
          [jobTitle]="authService.currentUserValue.data?.title || ''"></mpro-panel-dropdown>
        </div>
      </div>
    </div>
    <ng-template #demo>
      <button class="mpro-btn mpro-btn-primary" (click)="openMarketingWebsite()">
        <span>request demo</span>
      </button>
    </ng-template>
  </div>
</div>
<mpro-main-tabs *ngIf="isFreemium"></mpro-main-tabs>
